import Vue from 'vue';
import { apiPath } from '../constants';

export const Categories = Vue.resource(
  `${apiPath}/categories{/categoryId}{/type}/`,
  {},
  {
    getPublishRules: {
      params: {
        type: 'publish-rules',
      },
    },
  },
  {
    transformToCamelCase: true,
  },
);
